import { render } from "./bettingDetailList_white.vue?vue&type=template&id=9692a492&scoped=true"
import script from "./bettingDetailList_white.vue?vue&type=script&lang=js"
export * from "./bettingDetailList_white.vue?vue&type=script&lang=js"

import "@/styles/common.css?vue&type=style&index=0&id=9692a492&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&id=9692a492&scoped=true&lang=css"
import "./bettingDetailList_white.vue?vue&type=style&index=2&id=9692a492&scoped=true&lang=css"
import "@/styles/betWhite.css?vue&type=style&index=3&id=9692a492&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9692a492"]])

export default __exports__